
import React from "react";
import { Link } from "react-router-dom";
import { EmptyState, ParentPageHeader, PortalLoading, StatusBadge, useParentPortal } from "./parentPortalUtils";

function ParentChildrenPage() {
  const { data, loading, reload } = useParentPortal("parent-portal/children/");
  if (loading && !data) return <PortalLoading />;

  const children = data?.children || [];

  return (
    <div className="container-fluid py-4">
      <ParentPageHeader
        title="My Children"
        subtitle="Children officially linked to your parent account."
        icon="bi-people"
        actions={<button className="btn btn-light border" onClick={reload}>Refresh</button>}
      />

      <div className="row g-3">
        {children.length === 0 ? (
          <div className="col-12"><div className="card border-0 shadow-sm"><EmptyState title="No children linked" /></div></div>
        ) : children.map((child) => (
          <div className="col-md-6 col-xl-4" key={child.id}>
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body">
                <div className="d-flex justify-content-between gap-2">
                  <div>
                    <h5 className="fw-bold mb-1">{child.full_name}</h5>
                    <p className="text-muted small mb-1">{child.student_number || "No student number"}</p>
                    <p className="text-muted small mb-0">{child.class_group?.name || "No class group assigned"}</p>
                  </div>
                  <StatusBadge value={child.relationship} />
                </div>
                <div className="d-flex flex-wrap gap-2 mt-3">
                  <Link className="btn btn-success btn-sm" to={`/parent/children/${child.id}`}>Open Dashboard</Link>
                  <Link className="btn btn-light border btn-sm" to={`/parent/children/${child.id}/results`}>Reports</Link>
                  <Link className="btn btn-light border btn-sm" to={`/parent/children/${child.id}/finance`}>Fees</Link>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ParentChildrenPage;
